<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/myfavoritethings/form">写真を投稿する</router-link></li>
        </ul>
      </div>
    </div>
    <div class="contact">
      <div class="contact__title">
        <div class="container">
          <h2>MY FAVORITE THINGS<span>私のお気に入り</span></h2>
          <h2>写真を投稿する</h2>
          <ul class="contact__process step1">
            <li class="active">
              <span>1.入力</span>
            </li>
            <li>
              <span>2.確認</span>
            </li>
            <li>
              <span>3.完了</span>
            </li>
          </ul>
          <p>写真投稿の応募ページです。以下のフォームに必要情報をご入力のうえ、「写真投稿に関する規約」を確認して、確認画面へお進みください。<br>「写真投稿に関する規約」への同意がない場合は応募できません。</p>
        </div>
      </div>
      <div class="contact__content">
        <div class="container">
          <form class="form" @submit="submitConfirm">
            <div class="form__row">
              <div class="form__title">
                <label>応募するテーマ<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <div class="form__content__selected__holder">
                  <select
                    v-model="contact_meta.theme_id"
                    class="s_select"
                    name="theme_id"
                    :disabled="isLoading"
                  >
                    <option value="" disabled selected hidden>選択してください</option>
                    <option 
                      v-for="(item, index) in photo_theme"
                      :key="index"
                      :value="item.theme_id"
                    >{{ item.theme_name }}</option>
                  </select>
                  <div class="bg__select"><i class="arrow down"></i></div>
                </div>

                <p
                  v-if="errorMessage.theme_id"
                  class="form__error">
                  {{ errorMessage.theme_id }}
                </p>

                <p
                  v-else-if="errorMessage.theme_name"
                  class="form__error">
                  {{ errorMessage.theme_name }}
                </p>
              </div>
            </div>
            <div class="form__row">
              <div class="form__title">
                <label>氏名<span class="required">必須</span><span class="note_2">＊投稿作品の管理目的のみに利用し、WEBサイト上に公開・掲載されることはありません。</span></label>
              </div>
              <div class="form__content">
                <div class="form__content__holder">
                  <div class="form__content__holder__item">
                    <div class="form__content__holder__item__row">
                      <div class="form__title2">
                        <label>姓</label>
                      </div>
                      <input
                        v-model="contact_meta.last_name"
                        name="last_name"
                        class="i_name"
                        type="text"
                        maxlength="60"
                        :disabled="isLoading"
                      />
                    </div>
                    
                    <p
                      v-if="errorMessage.last_name"
                      class="form__error">
                      {{ errorMessage.last_name }}
                    </p>
                  </div>

                  <div class="form__content__holder__item">
                    <div class="form__content__holder__item__row">
                      <div class="form__title2">
                        <label class="label__two">名</label>
                      </div>
                      <input
                        v-model="contact_meta.first_name"
                        class="i_name"
                        type="text"
                        name="first_name"
                        maxlength="60"
                        :disabled="isLoading"
                      />
                    </div>
                    
                    <p
                      v-if="errorMessage.first_name"
                      class="form__error">
                      {{ errorMessage.first_name }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="form__row">
              <div class="form__title">
                <label>お住まい<span class="required">必須</span><span class="note_2">＊投稿作品の管理目的のみに利用し、WEBサイト上に公開・掲載されることはありません。</span></label>
              </div>
              
              <div class="form__content">
                <div class="form__content__holder three_col">
                  <div class="form__content__holder__item">
                    <div class="form__content__holder__item__row">
                      <div class="form__title2">
                        <label>街区</label>
                      </div>
                      <select
                        v-model="contact_meta.block"
                        class="s_select"
                        name="block"
                        :disabled="isLoading"
                      >
                        <option value="" disabled selected hidden>選択してください</option>
                        <option>SEA VILLAGE</option>
                        <option>SUN VILLAGE</option>
                        <option>PARK VILLAGE</option>
                      </select>
                      <div class="bg__select"><i class="arrow down"></i></div>
                    </div>

                    <p
                      v-if="errorMessage.block"
                      class="form__error sp">
                      {{ errorMessage.block }}
                    </p>
                  </div>

                  <div class="form__content__holder__item">
                    <div class="form__content__holder__item__row">
                      <div class="form__title2">
                        <label class="label__two">棟</label>
                      </div>
                      <select
                        v-model="contact_meta.building"
                        class="s_select"
                        name="building"
                        :disabled="isLoading"
                      >
                        <option value="" disabled selected hidden>選択してください</option>
                        <option>A棟</option>
                        <option>B棟</option>
                        <option>C棟</option>
                        <option>D棟</option>
                        <option>E棟</option>
                        <option>F棟</option>
                        <option>T棟</option>
                      </select>
                      <div class="bg__select"><i class="arrow down"></i></div>
                    </div>

                    <p
                      v-if="errorMessage.building"
                      class="form__error sp">
                      {{ errorMessage.building }}
                    </p>
                  </div>

                  <div class="form__content__holder__item">
                    <div class="form__content__holder__item__row">
                      <div class="form__title2">
                        <label class="label__two">号室</label>
                      </div>
                      <input
                        v-model="contact_meta.room_number"
                        class="i_name"
                        type="text"
                        name="room_number"
                        :disabled="isLoading"
                      />
                    </div>

                    <p
                      v-if="errorMessage.room_number"
                      class="form__error sp">
                      {{ errorMessage.room_number }}
                    </p>
                  </div>
                </div>
                <p
                  v-if="errorMessage.block"
                  class="form__error pc">
                  {{ errorMessage.block }}
                </p>
                
                <p
                  v-if="errorMessage.building"
                  class="form__error pc">
                  {{ errorMessage.building }}
                </p>

                <p
                  v-if="errorMessage.room_number"
                  class="form__error pc">
                  {{ errorMessage.room_number }}
                </p>
              </div>
            </div>
            <div class="form__row">
              <div class="form__title">
                <label>ニックネーム<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <input 
                  v-model="contact_meta.nick_name" 
                  type="text" 
                  name="nick_name"
                  :disabled="isLoading" 
                />
                
                <p
                  v-if="errorMessage.nick_name"
                  class="form__error">
                  {{ errorMessage.nick_name }}
                </p>
              </div>
            </div>
            <div class="form__row">
              <div class="form__title">
                <label>メールアドレス<span class="required">必須</span><span class="note_2">＊投稿作品の管理目的のみに利用し、WEBサイト上に公開・掲載されることはありません。</span></label>
              </div>
              <div class="form__content">
                <input
                  v-model="contact_meta.email_address"
                  type="text"
                  name="email_address"
                  :disabled="isLoading"
                />

                <p
                  v-if="errorMessage.email_address"
                  class="form__error">
                  {{ errorMessage.email_address }}
                </p>
              </div>
            </div>
            <div class="form__row">
              <div class="form__title">
                <label>メールアドレス(確認用)<span class="required">必須</span><span class="note_2">＊投稿作品の管理目的のみに利用し、WEBサイト上に公開・掲載されることはありません。</span></label>
              </div>
              <div class="form__content">
                <input
                  v-model="contact_meta.confirmation_email_address"
                  type="text"
                  name="confirmation_email_address"
                  :disabled="isLoading"
                />

                <p
                  v-if="errorMessage.confirmation_email_address"
                  class="form__error">
                  {{ errorMessage.confirmation_email_address }}
                </p>
              </div>
            </div>
            <div class="form__row">
              <div class="form__title">
                <label>電話番号<span class="required">必須</span><span class="note_2">＊ハイフンなしで入力してください</span><span class="note_2">＊投稿作品の管理目的のみに利用し、WEBサイト上に公開・掲載されることはありません。</span></label>
              </div>
              <div class="form__content">
                <input
                  v-model="contact_meta.phone_number"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  type="text"
                  name="phone_number"
                  maxlength="13"
                  placeholder="ハイフンなしで入力してください"
                  :disabled="isLoading"
                />

                <p
                  v-if="errorMessage.phone_number"
                  class="form__error">
                  {{ errorMessage.phone_number }}
                </p>
              </div>
            </div>
            <div class="form__row">
              <div class="form__title">
                <label>画像<span class="required">必須</span></label>
                <p>1点 / 静止画のみ / ファイル形式：JPG、JPEG、PNG / ファイル最大サイズ：10MB</p>
              </div>
              <div class="form__content">
                <div class="img_upload_button_holder">
                  <label class="img_upload_button" for="img_upload">
                    <span :class="{ 'disabled': isLoading }" class="button_upload">画像をアップロード</span>
                    <span>
                      <input 
                        id="img_upload" 
                        type="file"
                        name="photo_image"
                        @change="onFileChange"
                        :disabled="isLoading"
                      >
                    </span>
                  </label>
                  <span class="file_name_holder">
                    <span class="file_name">{{ contact_meta.fileName  }}</span>
                  </span>
                </div>
                
                <p
                  v-if="errorMessage.photo_image"
                  class="form__error">
                  {{ errorMessage.photo_image }}
                </p>
              </div>
            </div>
            <div class="form__row last_row">
              <div class="form__title">
                <label>コメント<span class="required">必須</span><span class="note">＊30文字まで</span></label>
              </div>
              <div class="form__content">
                <textarea
                  v-model="contact_meta.comment"
                  name="comment"
                  rows="5"
                  cols="50"
                  maxlength="30"
                  :disabled="isLoading"
                ></textarea>
                
                <p
                  v-if="errorMessage.comment"
                  class="form__error">
                  {{ errorMessage.comment }}
                </p>
              </div>
            </div>
            <div class="text__link">
              <a href="/myfavoritethings/rule" target="_blank">写真投稿に関する規約</a>に<wbr>同意の上、<wbr>送信してください。
            </div>
          </form>
          <div class="outside__form">
            <div class="form__button">
              <button
                v-if="isLoading"
                class="btn btn_myfavoritethings icon--white"
                disabled
              >
                写真投稿に関する規約に<wbr>同意して<wbr>送信する
              </button>
              
              <button
                v-else
                @click="submitValidateForm"
                class="btn btn_myfavoritethings icon--white"
              >
                写真投稿に関する規約に<wbr>同意して<wbr>送信する
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { RouterLink } from "vue-router";
import { metaData } from '@/utils/helper';
import { getListThemeName } from '@/utils/helper';
import axios from "axios";
import indexedDB from '@/utils/indexedDB';
export default {
  name: "MyfavoritethingsForm",
  data() {
    return {
      photo_theme: [
        // "HARUMI FLAGのイベント",
        // "HARUMI FLAGの暮らし自慢",
        // "HARUMI FLAGの私の好きなシーン",
        // "HARUMI FLAGの季節",
        // "HARUMI FLAGの思い出",
        // "HARUMI FLAGの暮らし自慢",
      ],
      contact_meta: {
        theme_id: "",
        first_name: "",
        last_name: "",
        block: "",
        building: "",
        room_number: "",
        nick_name: "",
        email_address: "",
        confirmation_email_address: "",
        phone_number: "",
        photo_image: "",
        comment: "",
        fileName: "",
      },
      errorMessage: {
        theme_name: "",
        first_name: "",
        last_name: "",
        block: "",
        building: "",
        room_number: "",
        nick_name: "",
        email_address: "",
        confirmation_email_address: "",
        phone_number: "",
        photo_image: "",
        comment: ""
      },
      isLoading: false,
    };
  },
  props: ['isEdit'],
  watch: {
    isEdit: {
      async handler(newVal) {
        if (newVal) {
          this.loadFormData();
        }
      },
      immediate: true
    }
  },
  methods: {
    async fetchPhotoFromIndexedDB() {
      try {
        const photo = await indexedDB.getItem('photo_image');
        
        if (photo) {
          this.contact_meta.photo_image = photo;
          if (!this.contact_meta.fileUrl) {
            this.contact_meta.fileUrl = URL.createObjectURL(photo);
          }
        }
      } catch (error) {
        console.error('Failed to fetch photo from IndexedDB:', error);
      }
    },

    onFileChange(event) {
      const files = event.target.files;
      
      if (files.length > 0) {
        const selectedFile = files[0];
        this.contact_meta.fileName = selectedFile.name;
        this.contact_meta.photo_image = selectedFile;
      } else {
        this.contact_meta.fileName = null;
        this.contact_meta.photo_image = null;
      }

    },

    submitConfirm(event) {
      event.preventDefault();
    },

    getPage: function () {
      getListThemeName('/photo_theme')
        .then((response) => {
          setTimeout(()=>{
            let dataList = response.data;
            this.photo_theme = response.data;
          },500)
        })
        .catch((e) => {
          console.log(e);
          this.contact_meta.theme_id = ""
        });
    },

    async submitValidateForm() {
      this.isLoading = true;
      this.errorMessage = {
        theme_id: "",
        theme_name: "",
        first_name: "",
        last_name: "",
        block: "",
        building: "",
        room_number: "",
        nick_name: "",
        email_address: "",
        confirmation_email_address: "",
        phone_number: "",
        photo_image: "",
        comment: ""
      };

      const formData = new FormData();

      for (const key in this.contact_meta) {
        let value = this.contact_meta[key];
        formData.append(key, value);
      }

      await axios.post('/api/myfavoritethings/form/validate', formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(async (response) => {
        if (response.data?.result == true) {
          let dataResponse = response.data?.data || {};
          const reader = new FileReader();
          //Response give file name instead a file
          dataResponse.fileName = dataResponse.photo_image;
          dataResponse.fileType = this.contact_meta?.photo_image?.type || '';
          dataResponse.fileUrl = URL.createObjectURL(this.contact_meta.photo_image);
          sessionStorage.setItem('validated_inputform', true);
          sessionStorage.setItem('validated_inputform_data', JSON.stringify(dataResponse));

          //set photo_image to indexedDB
          await indexedDB.setItem('photo_image', this.contact_meta.photo_image);

          this.$router.push('/myfavoritethings/form/confirm');
        }
      })
      .catch((error) => {
        console.log(error)
        let errorList = error?.response?.data?.error || []
        for (const errorResponse of errorList)
        {
          if (errorResponse?.fieldName) {
            this.errorMessage[errorResponse.fieldName] = errorResponse?.messageError || ""
          }
        }
      });
      this.isLoading = false;
    },

    async loadFormData() {
      if (sessionStorage.getItem('validated_inputform_data') !== null) {
        this.contact_meta = { ...JSON.parse(sessionStorage.getItem('validated_inputform_data')) };
        try {
          const photoImage = await fetch(this.contact_meta?.fileUrl || '');
          const blob = await photoImage.blob();
          const file = new File([blob], this.contact_meta.fileName, {
            type: blob.type,
            lastModified: new Date().getTime()
          });
          this.contact_meta.photo_image = file;
        } catch (error) {
          this.contact_meta.fileUrl = '';
          await this.fetchPhotoFromIndexedDB();
        }
      }
    }
  },
  created() {
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) {
        this.loadFormData();
      }
    });

    if (
      sessionStorage.getItem('token') == null
    ) {
      sessionStorage.removeItem('validated_inputform');
      sessionStorage.removeItem('validated_inputform_data');
      this.$router.push({
        name: 'Myfavoritethings',
        params: {
          isScrollToLogin: true
        }
      })
    }

    metaData(
      `写真を投稿する | HARUMIFLAGタウンポータル`,
      '中央区晴海・HARUMIFLAGのMY FAVORITE THINGS 写真を投稿するページです。',
      'HARUMIFLAGタウンポータル',
      'website'
    )
    this.getPage();
  },

  destroyed() {
    window.removeEventListener('pageshow', () => {});
  }
};
</script>